<template>
    <!-- BaseSearchItem.vue -->
    <v-card :flat="flat" :to="to" class="v-list-item pa-0 fill-height">
        <v-list-item>
            <!-- Icon -->
            <v-list-item-icon>
                <slot :item="item" name="icon">
                    <v-icon color="primary">{{ icon }}</v-icon>
                </slot>
            </v-list-item-icon>
            <v-list-item-content>
                <!-- Title -->
                <v-list-item-title class="search-item-text">
                    <slot :item="item" name="title">
                        {{ item.title }}
                    </slot>
                </v-list-item-title>
                <!-- Description -->
                <v-list-item-subtitle class="search-item-text">
                    <slot name="description">
                        {{ item.description }}
                    </slot>
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<style>
    .search-item-text {
        white-space: normal !important;
        word-wrap: break-word !important;
    }
</style>

<script>
    import {SEARCH_ITEM_ICON} from '@/store/static/base-icons'

    export default {
        name: 'BaseSearchItem',
        props: {
            /**
             * Toggle the elevation of the v-card component
             */
            flat: {
                type: Boolean,
                default: true
            },
            /**
             * The icon of the list item
             */
            icon: {
                type: String,
                default: SEARCH_ITEM_ICON
            },
            /**
             * The search result item i.e. {id: number, title: string, description: string}
             */
            item: {
                type: Object,
                required: true
            },
            /**
             * The route of the list item
             */
            to: {
                type: Object,
                required: false
            }
        }
    }
</script>
